












































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { Utils } from '@/globals/Utils';
import { eventsHub } from '@/main';

@Component({})
export default class DateInputWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public inputName!: string;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop([String, Number]) public dataAttribute!: string | number;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;   // to show the icon for the error message
  @Prop(Boolean) public isFutureDate!: boolean;      // to check that the date is valid
  @Prop({ type: Boolean, default: true }) public isDisabled!: boolean;
  @Prop({ type: Boolean, default: true }) public showDay!: boolean;
  @Prop({ type: Boolean, default: true }) public showMonth!: boolean;
  @Prop({ type: Boolean, default: true }) public showYear!: boolean;
  @Prop({ type: Boolean, default: true }) public isRtl!: boolean;
  @Prop({ type: [Number, String, Date], required: false }) public dateField;

  // set label for the component (header)
  @Prop(String) private title!: string;
  @Prop(String) private subLabel!: string;
  @Prop(String) private staticInputId!: string;
  @Prop(Boolean) private allowFutureDate: boolean = false;
  @Prop(Number) private maxLength!: number;
  private dateStr: string = '';
  private inputId: string = '';     // create unique id for each component
  private htmlName: string = '';    // the name of the text field

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
    this.$validator.extend('validDateStr',
      { // validation for valid date
        getMessage: (field: any) => eventsHub.$t('invalidDateStrMessage', { field }),
        validate: (dateStr: string) => {
          return this.validateDateStr(dateStr);
        },
      });
  }

  public mounted() {
    if (this.dateField && typeof this.dateField !== 'string') {
      this.initDate(this.dateField);
    }
  }

  public onKeyup(e) {
    if (this.dateStr.length < 10 && (e.key === '/' || isNaN(e.key))) {
      this.dateStr = this.dateStr.slice(0, -1);
    }
    if (e.key !== 'Backspace' && (this.dateStr.length === 2 || this.dateStr.length === 5)) {
      this.dateStr += '/';
    } else if (this.dateStr[2] && this.dateStr[2] !== '/') {
      const char2 = this.dateStr[2];
      this.dateStr = this.dateStr.substring(0, 2) + '/' + char2;
    } else if (this.dateStr[5] && this.dateStr[5] !== '/') {
      const char5 = this.dateStr[5];
      this.dateStr = this.dateStr.substring(0, 5) + '/' + char5;
    }
  }

  public updateValue() {
    const timestamp = Utils.DDMMYYYYStringToDate(this.dateStr);
    if (this.dateStr.length < 10) {
      this.$emit('input', '');
    } else {
      this.$emit('input', timestamp);
    }
  }

  public initDate(dateField) {
    this.dateStr = Utils.DDMMYYYYDateToString(dateField);
  }

  public validateDateStr(dateStr: string) {
    const day: any = dateStr.substring(0, 3);
    const month: any = dateStr.substring(3, 6);
    const year: any = dateStr.substring(6, 10);
    return !isNaN(Date.parse(month + day + year)) && +year >= 1900;
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = true;
    }
    validator.validDateStr = true;
    return validator;
  }

}
